import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { Field } from "../../components/neu/Field";
import { closeDay } from "../../api/accounting";
import { useApiError } from "../../hooks/useApiError";

export const ReconForm = ({ box, onDone }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [counted, setCounted] = useState("");
  const [reason, setReason] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const difference = (Number(counted || 0) - Number(box.balance)).toFixed(2);

  const submit = async () => {
    try {
      await closeDay({ cashbox_id: box.id, date, counted: Number(counted), reason: reason || null });
      toast.success(t("acct.reconciled"));
      onDone();
    } catch (error) {
      toast.error(describe(error));
    }
  };

  return (
    <NeuCard className="grid gap-4 p-5" data-testid="recon-form">
      <p className="text-sm font-bold">{t("acct.reconcile")} — {box.name}</p>
      <div className="grid gap-3 sm:grid-cols-3">
        <Field label={t("acct.date")} testId="recon-date" type="date" value={date} onChange={setDate} />
        <Field label={t("acct.counted")} testId="recon-counted" type="number" value={counted} onChange={setCounted} />
        <div>
          <p className="label-xs mb-2">{t("acct.difference")}</p>
          <p className={`font-mono text-lg font-bold ${Number(difference) === 0 ? "text-success" : "text-destructive"}`} dir="ltr" data-testid="recon-difference">
            {difference}
          </p>
        </div>
      </div>
      {Number(difference) !== 0 ? (
        <Field label={t("acct.differenceReason")} testId="recon-reason" value={reason} onChange={setReason} />
      ) : null}
      <NeuButton variant="primary" data-testid="recon-submit" disabled={counted === ""} onClick={submit}>
        {t("acct.closeDay")}
      </NeuButton>
    </NeuCard>
  );
};
